import header from "./employee-working-project-side-view.jpg";
import section1 from "./skizzen-eines-grundrisses.jpg";
import section2 from "./fassadenansicht-bauplan.webp";
import section3 from "./tablets-mit-grundriss.jpg";
import section4 from "./grundriss-3zimmer-terrasse.webp";
import section5 from "./side-view-man-holding-design-plan.jpg";
import section6 from "./grundriss-3zimmer-2bad.webp";

export { header, section1, section2, section3, section4, section5, section6 };
